//import { handleTabs } from '@/utils/routes'
let dayjs = require('dayjs')
export default {
  computed: {
    colSpan() {
      if (this.form.buildingCd == null) {
        return 9
      } else {
        if (this.form.proposalBase?.buildingCd.length > 1) {
          if (this.$route.query?.id) {
            return 9
          }
          return 15
        } else {
          return 9
        }
      }
    },
  },
  watch: {
    colSpan(val) {
      if (val) {
        this.jspan1 = 6
      }
    },
  },
  methods: {
    // 追加商品明細行数据
    addItemDetail() {
      let name = this.$route.name
      let id = this.form.proposalItemDetail.length + 1
      if (name == 'DPR01G03') {
        this.form.proposalItemDetail.push({
          itemDetailCd: null,
          itemDetailCdModel: {
            itmdtlnm: null,
          },
          inOutClass: '',
          planMonthlyProfitPrice: null,
          cdSpecification: null,
          averageYd: 0,
          preOrderPremium: 0,
          estimatedOriginalAmount: 0,
          estimatedGrossProfit: 0,
          estimatedGrossInterestRate: 0 + '%',
          cancelFlg: null,
          proposalDetailTableList: this.$baseLodash.cloneDeep(
            this.splitTableStructureList
          ),
          id: id,
        })
        // this.setYbList({ id: id })
      } else {
        this.form.proposalItemDetail.push({
          itemDetailCd: null,
          itemDetailCdModel: {
            itmdtlnm: null,
          },
          inOutClass: '',
          planProfitPrice: 0,
          planCostPrice: 0,
          estimatedGrossProfit: 0,
          estimatedGrossInterestRate: 0,
          cancelFlg: null,
          id: id,
        })
      }
    },
    // 商品明細の選択
    handleItemDetail(row) {
      let selectGood = []
      if (this.form.itemCd && this.form.itemCd.length > 0) {
        selectGood.push({
          itmcd: this.form.itemCd[0],
          itmnm: this.form.itemCdModel.itmnm[0],
        })
      }

      this.$modalGoodsDetailList(selectGood, false, function (data) {
        row.itemDetailCd = data[0].itmdtlcd
        row.itemDetailCdModel.itmdtlnm = data[0].itmdtlnm
      })
    },
    // 提案計画詳細月別を取得する
    setChildrenMonthColums() {
      this.$nextTick(() => {
        let list = new Array(12)
        for (let index = 4; index < 16; index++) {
          let label = `${index > 12 ? index - 12 : index}月`
          let data = {
            label: label,
            prop: `m${index}.value`,
            type: 'number',
            'min-width': 100,
            config: () => ({
              ctrl: 'input',
              type: 'number',
              disabled: (row) => {
                return row[`m${index}`].disabled
              },
              onInput: this.handleChangeInput,
            }),
          }
          list[index - 4] = data
        }
        this.preOrderAmountColumns.filter((item) => {
          if (item.label == '月别') {
            item.children = [...list]
          }
        })
      })
    },
    //提案計画商品明細内容をリセットする
    resetProposalItemDetail() {
      this.form.proposalItemDetail.forEach((item) => {
        item.itemDetailCd = null
        item.itemDetailCdModel.itmdtlnm = null
      })
    },
    getMonthDay(year, month) {
      return new Date(year, month + 1, 0).getDate()
    },
    getDataValue(str, format) {
      if (!str) return
      return Number(dayjs(str).format(format))
    },
    expandChange(row) {
      this.changeGoodInfo = row
      this.numberBlur()
    },
    numberBlur() {
      // setTimeout(() => {
      //   document.querySelectorAll('.el-input__inner.number').forEach((item) => {
      //     item.focus()
      //     item.blur()
      //   })
      // }, 0)
    },
    //契約管理画面を遷移する
    goToContractManagement() {
      this.$router.push({ name: 'DCN01G01' })
    },
    mergeColumn(columnName) {
      const spanOneArr = []
      let concatOne = 0
      let list = this.changeGoodInfo?.ybList || this.$refs.ydtable.dataSource
      list.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1)
        } else {
          //name 修改
          if (item[columnName] === list[index - 1][columnName]) {
            //第一列需合并相同内容的字段
            spanOneArr[concatOne] += 1
            spanOneArr.push(0)
          } else {
            spanOneArr.push(1)
            concatOne = index
          }
        }
      })
      return {
        one: spanOneArr,
      }
    },
    spanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.mergeColumn('periodCd').one[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      if (columnIndex === 1) {
        const _row = this.mergeColumn('ym').one[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      // let name = this.$route.name
      if (columnIndex === 16 || columnIndex === 17) {
        const _row = this.mergeColumn('ym').one[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
    },
    //更新履歴を見る
    viewHistory() {
      this.$refs.updateRecord.initData()
    },
    fetchData() {
      this.$refs.table.fetchData()
    },
    // 年度売上額また原価額の合計
    setExpectedAmountItemSum(row) {
      let total = 0
      Object.keys(row).filter((item) => {
        if (item.toString().startsWith('m')) {
          total += Number(row[item].value)
        }
      })
      row['sum'] = total
    },

    //年度売上額合計また原価額合計を取得する
    getExpectedAmountItemSum(ym, type, proposalDetailTableList) {
      return this.$baseLodash.find(proposalDetailTableList, {
        type: type,
        ym: ym,
      }).sum
    },
    // 提案計画詳細の年度当該期粗利益と当該期粗率をセットする
    setProposalDetailGrossProfitAndGrossRate(ym, proposalDetailTableList) {
      //年度売上額の合計を取得する
      let preOrderPremiumSum = this.getExpectedAmountItemSum(
        ym,
        this.$divisions.expectedAmountItemEnum.salesAmount.value,
        proposalDetailTableList
      )
      // 年度原価額の合計を取得する
      let estimatedOriginalAmountSum = this.getExpectedAmountItemSum(
        ym,
        this.$divisions.expectedAmountItemEnum.costAmount.value,
        proposalDetailTableList
      )
      // 年度の期粗利益を計算する
      // 年度売上額の合計 - 年度原価額の合計
      let currentGrossProfit =
        Number(preOrderPremiumSum) - Number(estimatedOriginalAmountSum)

      //当該期粗利益と当該期粗率をセットする
      this.setGrossProfitAndGrossRate(
        ym,
        proposalDetailTableList,
        currentGrossProfit,
        preOrderPremiumSum
      )
    },

    //当該期粗利益と当該期粗率をセットする
    setGrossProfitAndGrossRate(
      ym,
      proposalDetailTableList,
      currentGrossProfit,
      preOrderPremiumSum
    ) {
      let that = this
      proposalDetailTableList.filter((item) => {
        if (item.ym == ym) {
          // 当前年度的当該期粗利益
          item['currentGrossProfit'] = currentGrossProfit
          // 当前年度的当該期粗率 = （该期合计予定売上額/当前年度的当該期粗利益)× 100
          item['currentGrossRate'] = (function () {
            if (preOrderPremiumSum == 0) {
              return 0 + '%'
            }
            return (
              that.$baseLodash.round(
                (currentGrossProfit / preOrderPremiumSum) * 100,
                1
              ) + '%'
            )
          })()
        }
      })
    },
  },
}
